import {
  BillingTransaction,
  BillingTransactionStatus,
  BillingTransactionType,
} from "@/types/billing-transactions";

export function computeBalanceStats(transactions: BillingTransaction[]) {
  const currency = transactions[0]?.currency ?? "USD";

  const payments = transactions.filter(
    (tx) => tx.type === BillingTransactionType.PAYMENT,
  );

  const paidPayments = payments.filter(
    (tx) => tx.status === BillingTransactionStatus.SUCCEEDED,
  );

  const notPaidPayments = payments.filter(
    (tx) => tx.status !== BillingTransactionStatus.SUCCEEDED,
  );

  const creditMinor = paidPayments.reduce((sum, tx) => sum + tx.amount, 0);
  const debetMinor = notPaidPayments.reduce((sum, tx) => sum + tx.amount, 0);

  const balanceMinor = creditMinor - debetMinor;

  return {
    currency,
    debetMinor,
    creditMinor,
    balanceMinor,
  };
}
